import { createContext, useContext } from "react";
import CONTENT from "@/data/content.json";

const ContentCtx = createContext(CONTENT);

export const ContentProvider = ({ children }) => (
  <ContentCtx.Provider value={CONTENT}>{children}</ContentCtx.Provider>
);

export const useContent = () => useContext(ContentCtx);
